import { render } from "./KindergartenRetentionView.vue?vue&type=template&id=270ab456&scoped=true&ts=true"
import script from "./KindergartenRetentionView.vue?vue&type=script&lang=ts"
export * from "./KindergartenRetentionView.vue?vue&type=script&lang=ts"

import "./KindergartenRetentionView.vue?vue&type=style&index=0&id=270ab456&scoped=true&lang=css"
import "./KindergartenRetentionView.vue?vue&type=style&index=1&id=270ab456&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-270ab456"]])

export default __exports__